import { render, staticRenderFns } from "./PropertyLandlords.vue?vue&type=template&id=17f09a40"
import script from "./PropertyLandlords.vue?vue&type=script&lang=js"
export * from "./PropertyLandlords.vue?vue&type=script&lang=js"
import style0 from "./PropertyLandlords.vue?vue&type=style&index=0&id=17f09a40&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports